export default function HomeView() {
  return <h1 className="helloUser">Hello 👋</h1>;
}
